import {createContext, useContext, memo} from 'react'
import type {Context, ReactNode, ComponentType} from 'react'

import type {ProjectId} from '../../../types'

export const ContentContext: Context<(nestedProjectId: ProjectId) => ReactNode> = createContext(
  (_): ReactNode => null,
)
type NestedContentProps = {
  projectId: ProjectId
}
export const NestedContent: ComponentType<NestedContentProps> = memo(function NestedContent({
  projectId,
}: NestedContentProps) {
  const render = useContext(ContentContext)
  return <>{render(projectId)}</>
})

export const SubprojectContext: Context<(nestedProjectId: ProjectId, level: number) => ReactNode> =
  createContext((_, __): ReactNode => null)
type NestedSubprojectProps = {
  projectId: ProjectId
  level: number
}
export const NestedSubproject: ComponentType<NestedSubprojectProps> = memo(
  function NestedSubproject({projectId, level}: NestedSubprojectProps) {
    const render = useContext(SubprojectContext)
    return <>{render(projectId, level + 1)}</>
  },
)
